module.exports = __webpack_public_path__ + "static/img/mas-main.eae636c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Home-pics/mas-main.jpg
// module id = V7lH
// module chunks = 0